import { render, staticRenderFns } from "./product-info.vue?vue&type=template&id=154fb3bc"
import script from "./product-info.vue?vue&type=script&lang=js"
export * from "./product-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports